import React, { useState } from "react";
import Slider from "react-slick";
import Meat from "../assets/meat.png";
import Box from "../assets/11.png";
import Basket from "../assets/22.png";
import Burger from "../assets/burger.png";
import Dish from "../assets/dish.png";
import Chicken from "../assets/chicken.png";
import Cookies from "../assets/cookie.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from "react-router-dom";

const ProductSlider = ({ categories, setCategoryId, categoryId }) => {

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", color: 'var(--Dark_Grey, #32343E)', position: "absolute", top: '-10px' }}
                onClick={onClick}
            >
                <ArrowForwardIcon />
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", color: 'var(--Dark_Grey, #32343E)', position: "absolute", top: '-10px' }}
                onClick={onClick}
            >
                <ArrowBackIcon />
            </div>
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                }   
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }   
            },
            {
                breakpoint: 380,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }
            }
        ],
    };


    const textStyle = {
        color: 'var(--medium-grey)',
        fontFamily: 'var(--font-Gotham-Black)',
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '14px',/* 87.5% */
        cursor: "pointer",
    }

    console.log(categories);

    return (
        <div className="slider" style={{ margin: "0 80px" }}>
            <Slider style={{ margin: "0 30px" }}  {...settings}>
                {categories?.map((item) => {
                    return (
                        <>
                            <div className="mr-4 cursor-pointer" style={{ borderBottom: "2px solid var(--Basic_red)" }} onClick={() => setCategoryId(item.id)}>
                                <div className="d-flex align-items-center" style={{ width: item.width }}>
                                    <span className="mx-2" ><img src={item?.image} width={30} height={30} /></span>
                                    <span style={{ ...textStyle, color: categoryId === item.id ? "red" : "var(--medium-grey)" }}>{item?.name}</span>
                                </div>
                            </div>
                            {categoryId === item.id ? <div style={{ height: "3px", backgroundColor: "#EB252D", borderRadius: "10px", marginTop: 10 }}></div> : ""}
                        </>
                    )
                })}
            </Slider>
        </div>
    );
};

export default ProductSlider;